<div class="card-body">
    <div id="apex-radialbar-custom-angle-circle"></div>
</div>